module.exports = __webpack_public_path__ + "media/images/articles/entry_steps/img02-8b29ea230cfe74d8c922d7bd221fbce9.png";